import { FunctionComponent } from 'preact';
import cn from 'classnames';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useCast } from '../../hooks/CastProvider';
import { useTranslation } from '../../../../utils/useTranslation';
import { Typography } from '../Typography/Typography';
import { useViewportType } from '../../hooks/useViewportType';
import ns from '../../translations';
import { useCallback } from 'preact/hooks';
import { firePixelTracker } from '../../utils/vast';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';
import { useIcons } from '../../hooks/useIcons';

export const CastButton: FunctionComponent<IconButtonProps> = ({
  filled,
  ...props
}) => {
  const { t } = useTranslation(ns);
  const { isMobile } = useViewportType();
  const { isAvailable, isActive, deviceName, castingType } = useCast();
  const { trackEngagementUIElement } = useTpaasTracker();

  const handleCastingClick = useCallback(
    (e: MouseEvent) => {
      if (e.currentTarget instanceof Element) {
        trackEngagementUIElement({
          elementName: `${isActive ? 'Stop' : 'Start'} Casting`,
          elementType: e.currentTarget.tagName.toLowerCase(),
          name: 'Casting',
        });
      }
    },
    [isActive, trackEngagementUIElement]
  );

  const { Casting } = useIcons();

  if (!isAvailable || castingType !== 'chromecast') {
    return null;
  }

  return (
    <div
      className={cn('vgp-cast-button', { 'vgp-cast-button-filled': filled })}
      onClick={handleCastingClick}
    >
      {isActive && !isMobile && (
        <Typography
          variant="label"
          size="small"
          bold
          className="vgp-cast-button-label"
        >
          {t('Playing at', { device: deviceName })}
        </Typography>
      )}
      <IconButton {...props}>
        <span className="vgp-cast-button-icon">
          <google-cast-launcher />
          <Casting />
        </span>
      </IconButton>
    </div>
  );
};
